// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'//导入 Vuex 的文件： store.js
import axios from 'axios'
import 'lib-flexible/flexible'
import './assets/styles/reset.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { px2rem } from '../libs/utils';
Vue.prototype.$px2rem = px2rem;

// 导入vant组件
import Vant from 'vant'
import 'vant/lib/index.css'

Vue.config.productionTip = false

Vue.use(Vant)

Vue.use(VueAwesomeSwiper)

Vue.prototype.$axiso = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js